<template>
  <div class="wrap">
    <div class="con">
      <img src="./imgs/school1.jpeg" alt="">
      <img src="./imgs/school2.png" alt="">
      <img src="./imgs/school3.jpeg" alt="" />
      <img src="./imgs/school4.jpeg" alt="" />
      <img class="img_b" src="./imgs/school5.jpeg" alt="" />
    </div>
  </div>
</template>

<script>

export default {
  name: "info",
  data() {
    return {
    };
  },
  methods: {
    
  }
};
</script>

<style lang="scss" scoped>
.wrap{
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .con {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 50px;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .img_b{
      margin-bottom: 70px;
    }
  }
}
</style>
